import React from "react";
import { Modal, List } from "antd";
import { useSelector } from "react-redux";
import { Assets } from "../../../../constants/images";
import AvatarImage from "../../../Common/AvatarImage";

const SeenByModal = ({ visible, onClose, message, seenMembers }) => {
  const { allUsers } = useSelector((state) => state?.chats);

  // Get user details for seen members
  const getSeenUsersDetails = () => {
    if (!allUsers?.data || !seenMembers) return [];

    const seenUsers = [];
    seenMembers.forEach((userId) => {
      // Find user in the allUsers list
      const userProfile = allUsers.data.find((user) => user?.id == userId);
      seenUsers.push({
        id: userProfile?.id,
        name: userProfile?.name ?? "Deleted User",
        image: userProfile?.image ?? Assets.ProfilePlaceholder,
      });
    });

    return seenUsers;
  };

  const seenUsers = getSeenUsersDetails();

  return (
    <Modal
      title={
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <span>Seen By ({seenUsers.length})</span>
        </div>
      }
      open={visible}
      onCancel={onClose}
      footer={null}
      width={400}
      centered
      className="seen-by-modal"
    >
      <div
        style={{
          maxHeight: seenUsers.length > 3 ? "300px" : "none",
          overflowY: seenUsers.length > 3 ? "auto" : "hidden",
        }}
      >
        {seenUsers.length > 0 ? (
          <List
            dataSource={seenUsers}
            renderItem={(user) => (
              <List.Item
                style={{
                  padding: "12px 0",
                  borderBottom: "1px solid #f0f0f0",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    width: "100%",
                  }}
                >
                  <AvatarImage
                    src={user.image}
                    name={user.name}
                    placeholder={Assets.ProfilePlaceholder}
                    size={40}
                  />
                  <div>
                    <div
                      style={{
                        fontWeight: "500",
                        fontSize: "14px",
                        color: "#333",
                      }}
                    >
                      {user.name}
                    </div>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                      }}
                    >
                      Seen this message
                    </div>
                  </div>
                </div>
              </List.Item>
            )}
          />
        ) : (
          <div
            style={{
              textAlign: "center",
              padding: "40px 20px",
              color: "#999",
            }}
          >
            <div style={{ fontSize: "16px", fontWeight: "500" }}>
              No one has seen this message yet
            </div>
            <div style={{ fontSize: "14px", marginTop: "8px" }}>
              The message will appear as "seen" once other members open the chat
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default SeenByModal;
